import type { Appointment } from '@medplum/fhirtypes';
import {
  ZOOM_MEETING_ID_EXT,
  ZOOM_MEETING_IDENTIFIER_SYSTEM,
  ZOOM_MEETING_PASSWORD_EXT,
} from '@unify/fhir-model/constants';
import { resolveAppointmentModality } from '@/pages/appointments/utils/appointmentModality';

function extensionString(appt: Appointment | undefined, url: string): string | undefined {
  return appt?.extension?.find((e) => e.url === url)?.valueString?.trim();
}

export interface AppointmentZoomMeeting {
  meetingNumber: string;
  password: string;
}

/** Read Zoom meeting id/password from Appointment extensions (and identifier fallback). */
export function getZoomMeetingFromAppointment(
  appt: Appointment | undefined,
): AppointmentZoomMeeting {
  const fromExt = extensionString(appt, ZOOM_MEETING_ID_EXT);
  const fromIdent = appt?.identifier
    ?.find((i) => i.system === ZOOM_MEETING_IDENTIFIER_SYSTEM)
    ?.value?.trim();
  return {
    meetingNumber: fromExt ?? fromIdent ?? '',
    password: extensionString(appt, ZOOM_MEETING_PASSWORD_EXT) ?? '',
  };
}

export function appointmentExpectsZoomMeeting(appt: Appointment | undefined): boolean {
  if (!appt) return false;
  const modality = resolveAppointmentModality(appt);
  return modality === 'telehealth' || modality === 'hybrid';
}

export function appointmentHasZoomMeeting(appt: Appointment | undefined): boolean {
  return Boolean(getZoomMeetingFromAppointment(appt).meetingNumber);
}
